import React, { Component } from 'react';
import { TimelineMax } from 'gsap';

const propTypes = {

};

const defaultProps = {

};

class Splash extends Component {
    constructor(props) {
        super(props);

        this.timeline = null;

        this.refLogoMac = null;
        this.refLogoOnf = null;
        this.refLogoDaily = null;
    }

    componentDidMount() {
        this.timeline = new TimelineMax({
            paused: true,
        });

        this.timeline.fromTo([
            this.refLogoMac,
            this.refLogoOnf,
            this.refLogoDaily,
        ], 0.5, {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
        });

        this.timeline.to([
            this.refLogoDaily,
            this.refLogoOnf,
            this.refLogoMac,
        ], 0.5, {
            autoAlpha: 0,
        }, '+=1');
    }

    getTimeline() {
        return this.timeline;
    }

    render() {
        return (
            <div className="splash">
                <div className="inner">
                    <div
                        className="logo logo-mac"
                        ref={(ref) => { this.refLogoMac = ref; }}
                    />
                    <div
                        className="logo logo-onf"
                        ref={(ref) => { this.refLogoOnf = ref; }}
                    />
                    <div
                        className="logo logo-daily"
                        ref={(ref) => { this.refLogoDaily = ref; }}
                    />
                </div>
            </div>
        );
    }
}

Splash.propTypes = propTypes;
Splash.defaultProps = defaultProps;

export default Splash;



// WEBPACK FOOTER //
// ./components/partials/Splash.jsx